import { ApiHandler } from '@eshop/api-client'

import type { FormFields } from '#/App'

import type { FetchResponse } from '#/local/type'

export const Validate = {
    async checkRentalDamage(name: FormFields, value: string): Promise<{ valid: true } | { errors: FetchResponse[], valid: false }> {
        const body = new FormData()

        body.append(name, value)

        const api = new ApiHandler({
            path: '/form/rental-machine-damage-report-validate',
            method: 'POST',
            body,
            defaultContentType: false,
        })

        api.addResponseHandler('4xx', async (response) => {
            if (response.status === 400) {
                return api.getData(true)
            }
            await api.handleError()
        })

        const result = await api.send()

        if (result === undefined) {
            return { valid: true }
        }

        return {
            valid: false,
            errors: result.errors as FetchResponse[],
        }
    },
}
